import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../../../../types"
import { getServiceErrorMessage } from "../../../../helpers"
import { eocDraftPlanItemModifyResponse } from "../../../../../../../../types/gqlTypes/graphql"

export const changeMicroSnapsCountTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    id: "changeMicroSnapsCount",
    src: "changeMicroSnapsCount",
    onDone: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<eocDraftPlanItemModifyResponse>>(
        (ctx, evt) => {
          /*
          Updating lesson detail item from sectionAvailableItems will update the whole
          lesson details, including totalSeconds, meta data which has questionCount and interactionCount
          needed to display to the user
        */
          if (evt.data.sectionAvailableItems) {
            const updatedLessonFromSectionAvailableItems =
              evt.data.sectionAvailableItems.find(
                item => item.id === ctx.selectedLessonId
              )
            return {
              studyPlan: evt.data?.plan,
              lessonDetails: {
                ...updatedLessonFromSectionAvailableItems,
                selectedMicroSnapCount:
                  updatedLessonFromSectionAvailableItems.meta
                    .selectedMicroSnapCount
              }
            }
          }

          const updatedItemFromPlan = evt.data?.plan.sections
            .map(section => section.items)
            .flat()
            .find(item => item.contentId === ctx.selectedLessonId)

          const selectedMicroSnapCount =
            updatedItemFromPlan?.selectedMicroSnapCount ??
            ctx.lessonDetails.selectedMicroSnapCount

          return {
            studyPlan: evt.data?.plan,
            lessonDetails: {
              ...ctx.lessonDetails,
              // Update current count in lessonDetails too.
              selectedMicroSnapCount
            }
          }
        }
      )
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("changeMicroSnapsCount", {
            messageData: ["change lesson count"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
